export default "__VITE_ASSET__C3Nu6YD7__"